import { Link } from "@inertiajs/react";

type BackLinkProps = {
  url: string;
  message: string;
};

export function BackLink({ url, message }: BackLinkProps) {
  return (
    <p>
      <Link
        href={url}
        className="text-sm dark:text-gray-400 text-gray-700 hover:underline"
      >
        ← {message}
      </Link>
    </p>
  );
}
